import { Component } from "react"
import PropTypes from "prop-types"
import NoEventImage from "blank-states/registrations-no-event.svg"
import { HelperShelfMessage, HelperShelfTrigger } from "components/helper_shelf"

class EmptyEvents extends Component {
  noEvents() {
    const { isAdmin, orgHasEvents } = this.props

    return (
      <div>
        {isAdmin && !orgHasEvents ? (
          <p>To get started, create your first signup.</p>
        ) : (
          <p>No active signups</p>
        )}
      </div>
    )
  }

  render() {
    const { eventsCount, newEventUrl, isAdmin, isStripeConnected, stripeConnectUrl } = this.props

    return (
      <div className="blank-state py-5 px-3">
        <div className="blank-state__hero">
          <img src={NoEventImage} alt="No signups" />
        </div>
        <div className="blank-state__msg">
          {eventsCount > 0 ? (
            <div>There are no signups that match your search query.</div>
          ) : (
            <div>
              {this.noEvents()}
              {isAdmin && (
                <div>
                  <div className="d-f jc-c">
                    <a href={newEventUrl} className="create-btn btn2">
                      New signup
                    </a>
                    {!isStripeConnected && (
                      <div className="d-f ai-c">
                        <a href={stripeConnectUrl} className="ml-1 quiet-create-btn btn2">
                          Connect to Stripe
                        </a>
                        <span className="ml-1 font-size-4">
                          <HelperShelfTrigger id="connect_to_stripe" />
                        </span>
                      </div>
                    )}
                  </div>
                  {!isStripeConnected && (
                    <HelperShelfMessage id="connect_to_stripe">
                      <div className="ta-l">
                        <div
                          css={{
                            fontSize: "0.875rem",
                            marginBottom: "12px !important"
                          }}
                        >
                          <strong>Stripe Isn't Connected</strong>
                        </div>
                        <p
                          css={{
                            fontSize: "0.875rem !important",
                            lineHeight: "1.4",
                            marginTop: 0
                          }}
                        >
                          You'll need to connect your Registrations account to Stripe in order to
                          receive credit card payments. Stripe has an easy sign up process, no
                          monthly fees, and we've been able to partner with them to offer our
                          customers a rate of 2.15% + $0.30 per transaction. You can still use
                          Registrations to manage signups and track cash and check payments.
                        </p>
                      </div>
                    </HelperShelfMessage>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

const { bool, number, string } = PropTypes

EmptyEvents.propTypes = {
  eventsCount: number.isRequired,
  isAdmin: bool.isRequired,
  isOrgAdmin: bool.isRequired,
  isStripeConnected: bool.isRequired,
  newEventUrl: string.isRequired,
  stripeConnectUrl: string.isRequired,
  orgHasEvents: bool.isRequired
}

EmptyEvents.defaultProps = {
  eventsCount: 0,
  isAdmin: false,
  isOrgAdmin: false,
  isStripeConnected: false,
  newEventUrl: "",
  stripeConnectUrl: ""
}

export default EmptyEvents
